export default __webpack_public_path__ + "static/media/baseline-battery_charging_80-24px.16555ae4.svg";